import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="htmlslotelement" id="htmlslotelement"></a>
    <h1 {...{
      "id": "windowhtmlslotelement"
    }}>{`window.HTMLSlotElement`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/HTMLSlotElement"
      }}>{`Web APIs - HTMLSlotElement`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v7.0.0  `}</p>
    <a name="htmlslotelement-name" id="htmlslotelement-name"></a>
    <h2 {...{
      "id": "name--string"
    }}>{`name : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`A string used to get and set slot's name.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/HTMLSlotElement/name"
      }}>{`HTMLSlotElement - name`}</a>{`  `}</p>
    <a name="htmlslotelement-assignednodes" id="htmlslotelement-assignednodes"></a>
    <h2 {...{
      "id": "assignednodesoptions"
    }}>{`assignedNodes(options)`}</h2>
    <p>{`returns a sequence of the nodes assigned to this slot. If options object is used with flatten: "true",
If slottables is the empty list, then append each slottable child of slot, in tree order, to slottables.`}<br></br>{`
Refer `}<a parentName="p" {...{
        "href": "https://dom.spec.whatwg.org/#find-flattened-slotables"
      }}>{`find-flattened-slotables`}</a></p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Array`}</inlineCode>{` - An array of nodes`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/HTMLSlotElement/assignedNodes"
      }}>{`HTMLSlotElement - assignedNodes`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An object that sets options for the nodes to be returned`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.flatten`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A boolean value indicating whether to return the assigned nodes of any available child `}<inlineCode parentName="td">{`slot`}</inlineCode>{` elements (true) or not (false). Defaults to false.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="htmlslotelement-assignedelements" id="htmlslotelement-assignedelements"></a>
    <h2 {...{
      "id": "assignedelementsoptions"
    }}>{`assignedElements(options)`}</h2>
    <p>{`returns a sequence of the elements assigned to this slot. If options object is used with flatten: "true",
If slottables is the empty list, then append each slottable child of slot, in tree order, to slottables.`}<br></br>{`
Refer `}<a parentName="p" {...{
        "href": "https://dom.spec.whatwg.org/#find-flattened-slotables"
      }}>{`find-flattened-slotables`}</a></p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Array`}</inlineCode>{` - An array of elements`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/HTMLSlotElement/assignedElements"
      }}>{`HTMLSlotElement - assignedElements`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An object that sets options for the elements to be returned`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.flatten`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A boolean value indicating whether to return the assigned elements of any available child `}<inlineCode parentName="td">{`<slot>`}</inlineCode>{` elements (true) or not (false). Defaults to false`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      